module.exports = __webpack_public_path__ + "img/microplastics-process-5.4049ab62.png";